module.exports = __webpack_public_path__ + "c3ff5f8ece813a2f646138bbaf095df4.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/media3.jpg
// module id = 191
// module chunks = 0